import firebase from 'firebase/app';
import React, { useCallback } from 'react';
import { FaFacebookSquare as BrandIcon } from 'react-icons/fa';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    '&:hover': { background: '#0C6FB9' },
    background: '#1092F3',
    borderRadius: 4,
    color: '#FFF',
    composes: [
      'flex-columns',
      'flex-center',
      'items-center',
      'p12',
      'my6',
      'is-full-width',
    ],
    transition: 'background 0.3s',
  },
  icon: {
    composes: ['mr6', 'fs16'],
  },
  label: {
    composes: ['text-left'],
    width: 75,
  },
});

const FacebookButtonComponent = React.memo(() => {
  const classes = useStyles();

  const signinHandler = useCallback(() => {
    const provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  }, []);

  return (
    <button className={classes.button} type="button" onClick={signinHandler}>
      <BrandIcon className={classes.icon} />
      <span className={classes.label}>Facebook</span>
    </button>
  );
});

FacebookButtonComponent.displayName = 'FacebookButtonComponent';

export default FacebookButtonComponent;
